import { inject, Injectable } from '@angular/core'
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router'
import { PermissionsService } from '@client/Services/PermissionsService'
import User from '@client/User'

@Injectable()
export class LoggedInGuard implements CanActivate {
	public user: User

	public router: Router

	constructor() {
		const permissionService: PermissionsService = inject(PermissionsService)
		this.router = inject(Router)

		this.user = permissionService.user
	}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): boolean | UrlTree {
		if (this.user) {
			return true
		}

		return this.router.parseUrl(`/login?redirect=${state.url}`)
	}
}
